/**
 * 我销售的密函列表页面地址
 */
export const SECRET_AUCTION_SALE_LIST_PAGE_PATH = '/auction/secret/list/sale'
